import React from "react";
import { Timeline } from "../../../../components";

const TimelineList = () => {
  return (
    <div className="flex-1 py-5 rounded-xl shadow-xl inner-section px-6 overflow-auto">
      <div className="flex justify-between p-3">
        <h6>Timeline</h6>
        <p className="text-sm font-semibold text-gray-400 ">
          From (Sun,04-May-2025 11:45:00) To (Thu,10-Jul-2025 00:00:00)
        </p>
      </div>
      <Timeline
        data={[
          {
            task: "Job Created",
            taskBy: "Nethan",
            designation: "BDM",
            taskDate: "2025-07-10T00:00:00.000Z",
            applicant: "Mechael Vaughn",
          },
          {
            task: "Submit Job",
            taskBy: "Aden",
            designation: "Recruiter",
            taskDate: "2025-07-01T09:30:00.000Z",
            applicant: "Johnson Clark",
          },
          {
            task: "Submit Job",
            taskBy: "Aden",
            designation: "Recruiter",
            taskDate: "2025-06-03T14:15:00.000Z",
            applicant: "Mechael Williamson",
          },
          {
            task: "Job created",
            taskBy: "Nethan",
            designation: "BDM",
            taskDate: "2025-05-04T11:45:00.000Z",
            applicant: "Mechael Williamson",
          },
          {
            task: "Job created",
            taskBy: "Nethan",
            designation: "BDM",
            taskDate: "2025-05-04T11:45:00.000Z",
            applicant: "Mechael Williamson",
          },
          {
            task: "Job created",
            taskBy: "Nethan",
            designation: "BDM",
            taskDate: "2025-05-04T11:45:00.000Z",
            applicant: "Mechael Williamson",
          },
          {
            task: "Job created",
            taskBy: "Nethan",
            designation: "BDM",
            taskDate: "2025-05-04T11:45:00.000Z",
            applicant: "Mechael Williamson",
          },
        ]}
      />
    </div>
  );
};

export default TimelineList;
